import { general } from './general'
import { claim } from './claim'
import { clmRIRcvy } from './clmRIRcvy'

export const mutations = Object.assign({}, general, claim, clmRIRcvy)
